import { Box, Skeleton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LookUpTable from './LookUpTable'
import TradingWidget from '@/src/components/TradingWidget'
import CommonApi from '@/pages/api'
import { accentPalette } from '@/src/utils/sharePrice'

const MarketData = ({
  marketData,
  newMarketData = {},
  loading,
  newGraph = false,
  sectionId = 7,
  isDraft = false
}) => {
  const [isloading, setIsLoading] = useState(false)
  const [chartSection, setChartSection] = useState()

  useEffect(() => {
    if (!newGraph) return
    const controller = new AbortController()

    const fetchChartSection = async () => {
      setIsLoading(true)
      try {
        const response = await CommonApi({
          method: 'get',
          path: `show-chart/${sectionId}${isDraft ? '?status=draft' : ''}`,
          signal: controller.signal
        })
        if (response?.status) {
          setChartSection(response?.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        if (!controller.signal.aborted) setIsLoading(false)
      }
    }

    fetchChartSection()
    return () => controller.abort()
  }, [newGraph, sectionId, isDraft])

  if (newGraph) {
    if (isloading) return <Skeleton className="h-[29.563rem]" />

    const showChart = !!chartSection?.show_price_chart
    const showStats = !!chartSection?.show_score_cards
    if (!showChart && !showStats) return null

    const colors = accentPalette(chartSection?.p_color)

    return (
      <Box
        role="group"
        aria-label="Share price"
        className="[container-type:inline-size] w-full overflow-hidden bg-white border border-sharePrice-hairline rounded-2xl text-sharePrice-ink divide-y divide-sharePrice-hairline"
        style={{ '--sp-accent': colors.line, '--sp-accent-tint': colors.tint }}
      >
        {showChart && (
          // TradingView draws its header and range tabs above the plot and the
          // time axis below it inside one iframe, so the box holds those too:
          // 172px above (the header wraps on narrow cards) + 200px plot + 26px,
          // and 8px inset + 144px + 300px plot + 26px from 720px wide. These
          // match relait-widgets .wg-sp-chart.
          <Box className="h-[398px] share-wide:h-[478px] share-wide:px-2 share-wide:pt-2 [&_.tradingview-widget-container]:h-full [&_.tradingview-widget-container__widget]:h-full [&_iframe]:block [&_iframe]:h-full [&_iframe]:w-full [&_iframe]:min-h-0">
            <TradingWidget
              defaultPeriod={chartSection?.price_chart_default_period}
              accent={chartSection?.p_color}
            />
          </Box>
        )}
        {showStats && (
          <LookUpTable newGraph marketData={marketData} newMarketData={newMarketData} />
        )}
      </Box>
    )
  }

  return (
    <Box className="flex flex-col gap-y-8">
      <Typography variant="h5">Market Data</Typography>

      {loading ? <Skeleton className="h-[29.563rem]" /> : <TradingWidget />}
      <LookUpTable marketData={marketData} />
    </Box>
  )
}

export default MarketData
